import educationDegreesReducer from "./reducers";
export { default as educationDegreesTypes } from "./types";
export { default as educationDegreesOperations } from "./operations";
export default educationDegreesReducer;
